import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PillboxComponent } from './pillbox.component';
import { ButtonsModule } from '../buttons/buttons.module';
import { MaterialModule } from 'src/app/material.module';
import { PillboxDividerComponent } from './pillbox-divider/pillbox-divider.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  imports: [CommonModule, ButtonsModule, MaterialModule, NgxGoogleAnalyticsModule],
  declarations: [PillboxComponent, PillboxDividerComponent],
  exports: [PillboxComponent, PillboxDividerComponent],
})
export class PillboxModule {}
